import { ProjectDashboardViewModel } from "../../api/project-dashboard"
import { Typography } from "@material-ui/core"
import HorizontalBarChart from "./HorizontalBarChart"
import { STATUS_COLORS } from "../../../constants"
import { useTranslations } from "./useTranslations"

const useCompletedTasksBarChart = ({ projectDashboard }: CompletedTasksBarChartProps) => {
  const translations = useTranslations()
  const {
    numberOfCompletedTasks,
    numberOfCompletedOnTimeTasks,
    numberOfCompletedLateTasks,
    numberOfCompletedOtherTasks,
    completedOnTimeTasks,
    completedLateTasks,
    completedOtherTasks,
  } = projectDashboard
  const completedOnTimeTasksPercentage = ((numberOfCompletedOnTimeTasks / numberOfCompletedTasks) * 100).toFixed(1)
  const completedLateTasksPercentage = ((numberOfCompletedLateTasks / numberOfCompletedTasks) * 100).toFixed(1)
  const otherCompletedTasksPercentage = ((numberOfCompletedOtherTasks / numberOfCompletedTasks) * 100).toFixed(1)

  const displayChart = numberOfCompletedTasks > 0

  const onTimeColor = STATUS_COLORS.COMPLETED["1"]
  const lateColor = STATUS_COLORS.REJECTED["2"]
  const otherColor = STATUS_COLORS.NOT_STARTED["1"]

  const labels = [
    {
      label: translations.onTimeLabel,
      boxColor: onTimeColor,
    },
    {
      label: translations.lateLabel,
      boxColor: lateColor,
    },
    {
      label: translations.noScheduleLabel,
      boxColor: otherColor,
    },
  ]

  const data = [
    {
      value: numberOfCompletedOnTimeTasks,
      percentage: completedOnTimeTasksPercentage,
      tooltipContent: completedOnTimeTasks,
      backgroundColor: onTimeColor,
    },
    {
      value: numberOfCompletedLateTasks,
      percentage: completedLateTasksPercentage,
      tooltipContent: completedLateTasks,
      backgroundColor: lateColor,
    },
    {
      value: numberOfCompletedOtherTasks,
      percentage: otherCompletedTasksPercentage,
      tooltipContent: completedOtherTasks,
      backgroundColor: otherColor,
    },
  ]

  return {
    displayChart,
    labels,
    data,
    translations,
  }
}

const CompletedTasksBarChart = ({ projectDashboard }: CompletedTasksBarChartProps) => {
  const { displayChart, labels, data, translations } = useCompletedTasksBarChart({ projectDashboard })

  if (!displayChart) {
    return (
      <Typography variant="body2" color="textSecondary">
        {translations.noData}
      </Typography>
    )
  }

  return <HorizontalBarChart labels={labels} data={data} />
}

export default CompletedTasksBarChart
type CompletedTasksBarChartProps = {
  projectDashboard: ProjectDashboardViewModel
}
